import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LocationService {

  getGeoLocation(address: string): Promise<google.maps.GeocoderResult> {
    let geocoder = new google.maps.Geocoder();
    return new Promise((resolve, reject) => {
      geocoder.geocode({
        'address': address,
        componentRestrictions: { country: 'es' }
      }, (results, status) => {
        if (status == google.maps.GeocoderStatus.OK) {
          resolve(Array.isArray(results) ? results[0] : null);
        } else {
          resolve(null);
        }
      });
    });
  }

  getCurrentLocation(): Promise<google.maps.LatLngLiteral> {
    return new Promise((resolve, reject) => {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            if (position) {
              let lat = position.coords.latitude;
              let lng = position.coords.longitude;
              const location = {
                lat,
                lng,
              };
              resolve(location);
            }
          },
          (error) => console.log(error)
        );
      } else {
        reject('Geolocation is not supported by this browser.');
      }
    });
  }

  getCurrentAddress(location: google.maps.LatLngLiteral)
    : Promise<google.maps.GeocoderResult> {
    return new Promise((resolve, reject) => {
      let geocoder = new google.maps.Geocoder;
      geocoder.geocode({
        'location': location
      }, function (results) {
        if (results[0]) {
          resolve(results[0]);
        } else {
        }
      });
    });
  }

  getClosestLocation(
    lat1: string | number,
    lon1: string | number,
    positions: google.maps.LatLngLiteral[],
    unit: 'K' | 'N' = 'K') {
    lat1 = Number(lat1);
    lon1 = Number(lon1);
    const distances = [];

    for (const position of positions) {
      let lat2 = position.lat;
      let lon2 = position.lng;
      const radlat1 = Math.PI * lat1 / 180;
      const radlat2 = Math.PI * lat2 / 180;
      const theta = lon1 - lon2;
      const radtheta = Math.PI * theta / 180;
      let dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
      if (dist > 1) {
        dist = 1;
      }
      dist = Math.acos(dist);
      dist = dist * 180 / Math.PI;
      dist = dist * 60 * 1.1515;
      if (unit == 'K') { dist = dist * 1.609344; }
      if (unit == 'N') { dist = dist * 0.8684; }
      distances.push(dist);
    }

    const index = distances.findIndex(d => d === Math.min(...distances));
    return { closestPosition: positions[index] || null, markerOptionsClosestIndex: index };
  }

  findCenterLocation(markers: { lat: number, lng: number; }[]) {
    return {
      lat: this.getCenter('lat', markers),
      lng: this.getCenter('lng', markers)
    };
  }

  private getCenter(prop: 'lat' | 'lng', markers: { lat: number, lng: number; }[]) {
    let values = markers.map(m => m[prop]);
    let min = Math.min(...values);
    let max = Math.max(...values);
    if (prop === 'lng' && (max - min > 180)) {
      values = values.map(val => val < max - 180 ? val + 360 : val);
      min = Math.min(...values);
      max = Math.max(...values);
    }
    let result = (min + max) / 2;
    if (prop === 'lng' && result > 180) {
      result -= 360;
    }
    return result;
  }

}
